import { Injectable, inject } from '@angular/core';
import {ApiEmergencyStopResponseDto, ApiKillSwitchResponseDto, EmergencyStopApiService, KillSwitchApiService} from '@birco/rainmesh-api';
import {Observable} from 'rxjs';
import {KillSwitchStateService} from '../api/kill-switch-state-service.interface';

@Injectable({
  providedIn: 'root'
})
export class KillSwitchStateServiceImpl implements KillSwitchStateService {
  private killSwitchApiService = inject(KillSwitchApiService);
  private emergencyStopApiService = inject(EmergencyStopApiService);


  getKillSwitch(): Observable<ApiKillSwitchResponseDto> {
    return this.killSwitchApiService.getKillSwitch();
  }

  triggerKillSwitch(options: { value: boolean }): Observable<ApiKillSwitchResponseDto> {
    return this.killSwitchApiService.triggerKillSwitch({
      newState: options.value,
    });
  }

  getEmergencyStop(): Observable<ApiEmergencyStopResponseDto> {
    return this.emergencyStopApiService.getEmergencyStop();
  }

  triggerEmergencyStop(): Observable<ApiEmergencyStopResponseDto> {
    return this.emergencyStopApiService.triggerEmergencyStop({
      newState: true,
    });
  }
}
